import { ElementType } from "react";
import HomeIcon from "../assets/icons/HomeIcon";
import OverviewIcon from "../assets/icons/sidebar/OverviewIcon";
import { Role } from "../types";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: Role[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const BsrmSidebarMenu: MenuTypes[] = [
  {
    name: "Sheba Portal",
    path: "/admin/dashboard",
    icon: HomeIcon,
    role: [],
  },
  {
    name: "Payment Dashboard",
    path: "/admin/bsrm",
    icon: OverviewIcon,
    role: ["BSRM_USER"],
    children: [
      {
        name: "Dashboard",
        path: "/admin/bsrm/dashboard",
        role: ["BSRM_USER"],
      },
      {
        name: "Statement",
        path: "/admin/bsrm/statement",
        role: ["BSRM_USER"],
      },
      {
        name: "Dealer List",
        path: "/admin/bsrm/dealer-list",
        role: ["BSRM_USER"],
      },
      {
        name: "Trader List",
        path: "/admin/bsrm/trader-list",
        role: ["BSRM_USER"],
      },
      {
        name: "Retailer List",
        path: "/admin/bsrm/retailer-list",
        role: ["BSRM_USER"],
      },
    ],
  },
];

export default BsrmSidebarMenu;
